<template>
  <modal-layout title="Connect Garmin Connect">
    <p v-if="garminPrimary" class="mt-4 text-base">
      Garmin will ask which data you want to share. FormBeat needs all of it —
      <b>including historical data</b>
      , which is what lets us analyze your past rides and know your fitness from day one instead of starting from zero.
    </p>
    <p v-else class="mt-4 text-base">
      Garmin will ask which data you want to share. FormBeat needs all of it —
      <b>including historical data</b>
      , which is what lets your sleep and HRV baselines work from day one instead of after a week of waiting.
    </p>

    <!-- Stylised illustration of Garmin's consent screen, not a screenshot -->
    <div class="bg-gray-50 p-4 mt-5 border rounded-md">
      <div class="mb-3 text-xs font-semibold tracking-wide text-gray-500 uppercase">On the next screen, tick every box</div>
      <ul>
        <li v-for="permission in permissions" :key="permission.label" class="last:mb-0 flex items-start mb-3">
          <span class="bg-primary flex items-center justify-center flex-shrink-0 w-5 h-5 mt-px rounded">
            <svg viewBox="0 0 20 20" class="w-3 h-3 text-white fill-current">
              <path d="M7.6 14.2 3.4 10l1.4-1.4 2.8 2.8 7-7L16 5.8z" />
            </svg>
          </span>
          <div class="ml-3">
            <div class="text-sm font-medium">{{ permission.label }}</div>
            <div class="text-xs text-gray-500">{{ permission.description }}</div>
          </div>
        </li>
      </ul>
    </div>

    <p v-if="garminPrimary" class="mt-4 text-sm text-gray-500">You can change what's shared anytime from your Garmin Connect account settings.</p>
    <p v-else class="mt-4 text-sm text-gray-500">Your activities keep coming from Strava — connecting Garmin only adds the overnight recovery data.</p>

    <template slot="footer">
      <div class="flex justify-end">
        <AppButton class="mr-2" secondary small @click="cancel()">Cancel</AppButton>
        <AppButton primary small @click="submit()">Continue to Garmin</AppButton>
      </div>
    </template>
  </modal-layout>
</template>

<script>
export default {
  name: 'ConnectGarminModal',

  props: {
    // Garmin is (or will be) the user's ride source — signup, reconnect, or a
    // Garmin-only user in Settings. Default copy targets Strava users adding
    // Garmin for overnight recovery data.
    garminPrimary: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    permissions() {
      if (this.garminPrimary) {
        return [
          { label: 'Activities', description: 'Your rides — everything FormBeat analyzes starts here' },
          { label: 'Historical data', description: "Easy to miss — without it we can't see any ride from before today" },
          { label: 'Daily health stats', description: 'Resting heart rate, stress and Body Battery' },
          { label: 'Sleep', description: 'Duration, stages and your nightly sleep score' }
        ]
      }

      return [
        { label: 'Daily health stats', description: 'Resting heart rate, stress and Body Battery' },
        { label: 'Sleep', description: 'Duration, stages and your nightly sleep score' },
        { label: 'Historical data', description: 'Easy to miss — without it your baselines start from scratch' },
        { label: 'Activities', description: 'A backup source for your rides if Strava ever goes down' }
      ]
    }
  },

  methods: {
    cancel() {
      this.$emit('close', false)
    },
    submit() {
      this.$emit('close', true)
    }
  }
}
</script>
